module.exports = __webpack_public_path__ + "img/img22.77a948c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/08/img22.jpg
// module id = 319
// module chunks = 0